export const removeHTMLTagsFromString = (str: string) => {
  if (!str) return '';
  return str
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/?[^>]+(>|$)/g, '')
    .replace(/\s+/g, ' ')
    .replace(/amp;/g, '')
    .trim();
};

export const extractContentFromHTML = (str: string) => {
  const span = document.createElement('span');
  span.innerHTML = str;
  return span.textContent || span.innerText;
}
